import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})

export class DataoptionsService {
  ip = environment.ipServer;
  constructor(private http: HttpClient) {
  }

  getRackCahcingOptions(): Observable<string[]> {
    let url = `${this.ip}/api/CachingOptions/GetRackCachingOptions`;
    return this.http.get<string[]>(url).pipe(
      tap((data) => data),
      catchError(this.handleError)
    );
  }

  saveRackCachingOptions(options : string[]){
    let url = `${this.ip}/api/CachingOptions/SaveRackCacheOptions`;
    return this.http.post(url, options,{ observe: 'response' });
  }

  private handleError(err: HttpErrorResponse): Observable<never> {
    let errorMessage = '';
    if (err.error instanceof ErrorEvent) {
      errorMessage = `An error occurred: ${err.error.message}`;
    } else {
      errorMessage = `Server returned code: ${err.status}, error message is: ${err.message}`;
    }
    console.error(errorMessage);
    return throwError(errorMessage);
  }
}

